// Action types for Schedule Reports module

// List of scheduled reports
export const SET_SCHEDULED_REPORTS_LIST = 'SET_SCHEDULED_REPORTS_LIST';

// Create/Save schedule
export const SET_SCHEDULE_CREATED = 'SET_SCHEDULE_CREATED';
export const SET_SCHEDULE_SAVING = 'SET_SCHEDULE_SAVING';

// Update schedule
export const SET_SCHEDULE_UPDATED = 'SET_SCHEDULE_UPDATED';
export const SET_SCHEDULE_UPDATING = 'SET_SCHEDULE_UPDATING';

// Delete schedule
export const SET_SCHEDULE_DELETED = 'SET_SCHEDULE_DELETED';
export const SET_SCHEDULE_DELETING = 'SET_SCHEDULE_DELETING';

// Schedule status (Active/Paused)
export const SET_SCHEDULE_STATUS_UPDATED = 'SET_SCHEDULE_STATUS_UPDATED';

// Schedule details
export const SET_SCHEDULE_DETAILS = 'SET_SCHEDULE_DETAILS';

// Execution logs
export const SET_SCHEDULE_EXECUTION_LOGS = 'SET_SCHEDULE_EXECUTION_LOGS';

// Loading states
export const SET_SCHEDULES_LOADING = 'SET_SCHEDULES_LOADING';
export const SET_SCHEDULE_DETAIL_LOADING = 'SET_SCHEDULE_DETAIL_LOADING';

// Error states
export const SET_SCHEDULES_ERROR = 'SET_SCHEDULES_ERROR';
export const CLEAR_SCHEDULES_ERROR = 'CLEAR_SCHEDULES_ERROR';

// Pagination
export const SET_SCHEDULES_PAGINATION = 'SET_SCHEDULES_PAGINATION';

// Reports dropdown for schedule creation
export const SET_AVAILABLE_REPORTS_FOR_SCHEDULE = 'SET_AVAILABLE_REPORTS_FOR_SCHEDULE';

// Published reports for schedule creation
export const SET_PUBLISHED_REPORTS_LIST = 'SET_PUBLISHED_REPORTS_LIST';
export const SET_PUBLISHED_REPORTS_LOADING = 'SET_PUBLISHED_REPORTS_LOADING';
